import { Command } from "commander";
import { fatalError } from "../ux/errors.js";

const COMMANDS = [
  "start",
  "go",        // alias for start
  "intake",
  "estimate",
  "init",
  "track",
  "reconcile",
  "calibrate",
  "spend",
  "import",
  "status",
  "pricing",
  "doctor",
  "completions",
  "advanced",
];

const GLOBAL_FLAGS = ["--help", "--version"];

export function generateBashCompletion(): string {
  const words = [...COMMANDS, ...GLOBAL_FLAGS].join(" ");
  return `#!/bin/bash
# bash completion for fathom

_fathom() {
  local cur="\${COMP_WORDS[COMP_CWORD]}"
  local commands="${words}"
  COMPREPLY=( $(compgen -W "\${commands}" -- "\${cur}") )
  return 0
}

complete -F _fathom fathom
`;
}

export function generateZshCompletion(): string {
  const words = [...COMMANDS, ...GLOBAL_FLAGS].join(" ");
  return `#compdef fathom
# zsh completion for fathom

_fathom() {
  local -a commands
  commands=(${words})
  compadd -a commands
}

_fathom "$@"
`;
}

export const completionsCommand = new Command("completions")
  .description("Generate shell completion scripts")
  .argument("<shell>", "Shell type: bash or zsh")
  .action((shell: string) => {
    switch (shell) {
      case "bash":
        process.stdout.write(generateBashCompletion());
        break;
      case "zsh":
        process.stdout.write(generateZshCompletion());
        break;
      default:
        fatalError(
          `Unsupported shell "${shell}"`,
          "Only bash and zsh are supported",
          "Use: fathom completions bash|zsh",
        );
    }
  });
